<ng-container *ngFor="let flight of day.flights; let i = index">
  <ng-template #technicalStopoverTpl>
    <ng-container *ngIf="flight.segments[0].technicalStopover">
      <ng-container *ngIf="flight.segments[0].technicalStopover.noInfo; else stopoverDetails">
        <p class="col-12 technical-stopover">{{ "ITINERARY.TRANSPORT.FLIGHT.TECHNICAL_STOPOVER" | translate }}</p>
      </ng-container>
      <ng-template #stopoverDetails>
        <p class="col-12 technical-stopover">
          {{ "ITINERARY.TRANSPORT.FLIGHT.TECHNICAL_STOPOVER_DETAILS" | translate }} {{ flight.segments[0].technicalStopover.locationName }}, {{ "ITINERARY.TRANSPORT.FLIGHT.ARRIVAL" | translate }} {{ flight.segments[0].technicalStopover.arrival }}, {{ "ITINERARY.TRANSPORT.FLIGHT.DEPARTURE_TIME" | translate }} {{ flight.segments[0].technicalStopover.departure }}
        </p>
      </ng-template>
    </ng-container>
  </ng-template>

  <ng-template #flightNotesTpl>
    <div class="row" *ngIf="flight.notes">
      <div class="col-12 flight-notes text-default">
        <ng-container *ngFor="let item of flight.notes">
          <ng-container *ngIf="state === 'Preventivo'">
            <ng-container *ngIf="item.id.endsWith('itinerario_preventivo')">
              <span [innerHTML]="item.text | safeHtml"></span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="state === 'Confermata'">
            <ng-container *ngIf="item.id.endsWith('itinerario_conferma')">
              <span [innerHTML]="item.text | safeHtml"></span>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <div class="container mt-3" [id]="flight?.code ? 'svc-' + flight.code : null" *ngIf="!enableFlightPassengers">
    <div class="row">
      <div class="col-sm-6 col-md-4 text-left">
        <h4>
          <small>{{ "ITINERARY.TRANSPORT.FLIGHT.DEPARTURE" | translate }}</small>
          {{ getFirstSegment(flight).departure.airportName }}
          <small>{{ "ITINERARY.TRANSPORT.FLIGHT.TO" | translate }}</small>
          {{ getLastSegment(flight).arrival.airportName }}
        </h4>
      </div>

      <div class="col-sm-6 col-md-8 text-center">
        <div class="row">
          <app-flight-segment-detail class="col-sm-12 col-md-3 offset-md-1" [segment]="flight.segments[0]"
            [type]="'departure'">
          </app-flight-segment-detail>

          <div class="col-sm-12 col-md-2 p-0 d-flex align-items-center justify-content-center">
            <div class="text-center">
              <div class="flight-duration-wrapper">
                <div class="flight-total-duration" *ngIf="getFlightDuration(flight)">{{ getFlightDuration(flight) }}</div>
                <img
                  src="assets/images/steps_{{ getStopovers(flight.segments) }}.png"
                  alt="{{ getStopovers(flight.segments) }} steps">

                <em class="fa fa-plane itinerary-flight ml-2"></em>
              </div>

              <div *ngIf="isDirect(flight.segments); else flightWithStopovers"></div>

              <ng-template #flightWithStopovers>
                <button class="btn btn-outline-secondary btn-sm rounded-pill" type="button" (click)="isCollapsed = !isCollapsed">
                    {{ getStopovers(flight.segments) }} {{ "ITINERARY.TRANSPORT.FLIGHT.STOPOVER" | translate }}
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.48763 7.7418L10.721 10.9751L13.9543 7.7418C14.2793 7.4168 14.8043 7.4168 15.1293 7.7418C15.4543 8.0668 15.4543 8.5918 15.1293 8.9168L11.3043 12.7418C10.9793 13.0668 10.4543 13.0668 10.1293 12.7418L6.3043 8.9168C5.9793 8.5918 5.9793 8.0668 6.3043 7.7418C6.6293 7.42513 7.16263 7.4168 7.48763 7.7418Z" fill="#A0A0A0"/>
                    </svg>
                </button>
              </ng-template>
            </div>
          </div>

          <app-flight-segment-detail class="col-sm-12 col-md-3" [segment]="getLastSegment(flight)"
            [type]="'arrival'" [showLogo]="false">
          </app-flight-segment-detail>

          <div class="col-sm-3 d-none d-md-block">
              <div class="d-flex align-items-center text-left-sm">
                  <div class="flight-details-info">
                      <ng-container *ngIf="flight.segments[0].baggageInfo != null && flight.segments[0].baggageInfo.length > 0; else noBaggage">
                        <div class="flight-icon d-flex align-items-start text-left">
                            <svg class="mr-2" style="width: 15px;" width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.40625 14.1657H3.09375V6.29071H4.40625V14.1657ZM7.25 14.1657H5.9375V6.29071H7.25V14.1657ZM10.0938 14.1657H8.78125V6.29071H10.0938V14.1657ZM10.9688 3.66571H9.21875V1.04071C9.21875 0.55946 8.825 0.16571 8.34375 0.16571H4.84375C4.3625 0.16571 3.96875 0.55946 3.96875 1.04071V3.66571H2.21875C1.25625 3.66571 0.46875 4.45321 0.46875 5.41571V15.0407C0.46875 16.0032 1.25625 16.7907 2.21875 16.7907C2.21875 17.272 2.6125 17.6657 3.09375 17.6657C3.575 17.6657 3.96875 17.272 3.96875 16.7907H9.21875C9.21875 17.272 9.6125 17.6657 10.0938 17.6657C10.575 17.6657 10.9688 17.272 10.9688 16.7907C11.9312 16.7907 12.7188 16.0032 12.7188 15.0407V5.41571C12.7188 4.45321 11.9312 3.66571 10.9688 3.66571ZM5.28125 1.47821H7.90625V3.66571H5.28125V1.47821ZM10.9688 15.0407H2.21875V5.41571H10.9688V15.0407Z" fill="#191847"/>
                            </svg>                                                                                    
                            <p class="m-0 bag-info" [innerHTML]="flight.segments[0].baggage | safeHtml"></p>
                        </div>
                      </ng-container>
                      <ng-template #noBaggage>
                        <div class="flight-icon d-flex align-items-start text-left">
                            <svg class="mr-2" style="width: 15px;" width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.40625 14.1657H3.09375V6.29071H4.40625V14.1657ZM7.25 14.1657H5.9375V6.29071H7.25V14.1657ZM10.0938 14.1657H8.78125V6.29071H10.0938V14.1657ZM10.9688 3.66571H9.21875V1.04071C9.21875 0.55946 8.825 0.16571 8.34375 0.16571H4.84375C4.3625 0.16571 3.96875 0.55946 3.96875 1.04071V3.66571H2.21875C1.25625 3.66571 0.46875 4.45321 0.46875 5.41571V15.0407C0.46875 16.0032 1.25625 16.7907 2.21875 16.7907C2.21875 17.272 2.6125 17.6657 3.09375 17.6657C3.575 17.6657 3.96875 17.272 3.96875 16.7907H9.21875C9.21875 17.272 9.6125 17.6657 10.0938 17.6657C10.575 17.6657 10.9688 17.272 10.9688 16.7907C11.9312 16.7907 12.7188 16.0032 12.7188 15.0407V5.41571C12.7188 4.45321 11.9312 3.66571 10.9688 3.66571ZM5.28125 1.47821H7.90625V3.66571H5.28125V1.47821ZM10.9688 15.0407H2.21875V5.41571H10.9688V15.0407Z" fill="#A0A0A0"/>
                                <line x1="0" y1="17.5" x2="13" y2="0.5" stroke="#CC0000" stroke-width="1.5"/>
                            </svg>
                            <p class="m-0 bag-info text-muted">{{ "ITINERARY.TRANSPORT.FLIGHT.NO_BAGGAGE" | translate }}</p>
                        </div>
                      </ng-template>
                      <div class="flight-icon d-flex align-items-baseline text-left">
                          <svg class="mr-2" style="width: 15px;" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.77508 3.35072C1.98758 2.79072 1.79508 1.70572 2.34633 0.909466C2.89758 0.121966 3.99133 -0.0705344 4.78758 0.480716C5.57508 1.04072 5.76758 2.12572 5.21633 2.92197C4.65633 3.70947 3.57133 3.90197 2.77508 3.35072ZM12.0938 15.9157C12.0938 15.4345 11.7001 15.0407 11.2188 15.0407H5.90758C4.61258 15.0407 3.51008 14.0957 3.31758 12.8182L1.73383 5.22322C1.65508 4.82947 1.30508 4.54072 0.893834 4.54072C0.351334 4.54072 -0.0511659 5.03947 0.0538341 5.57322L1.58508 13.0807C1.91758 15.2157 3.75508 16.7907 5.91633 16.7907H11.2188C11.7001 16.7907 12.0938 16.397 12.0938 15.9157ZM11.6913 11.5407H8.02508L7.12383 7.95322C8.24383 8.58322 9.42508 9.07322 10.7113 9.09072C11.2188 9.09947 11.6301 8.66197 11.6301 8.15447C11.6301 7.63822 11.2013 7.24447 10.6851 7.22697C9.53883 7.19197 8.38383 6.73697 7.52633 6.06322L6.09133 4.95197C5.89008 4.79447 5.66258 4.68947 5.42633 4.61947C5.14633 4.54072 4.84883 4.51447 4.56008 4.56697H4.54258C3.46633 4.75947 2.74883 5.78322 2.93258 6.85072L4.11383 12.0307C4.35883 13.2732 5.43508 14.1657 6.69508 14.1657H12.6888L15.3926 16.2832C15.7601 16.572 16.2851 16.537 16.6088 16.2132C17.0026 15.8195 16.9588 15.1807 16.5213 14.8395L12.7676 11.9082C12.4613 11.672 12.0851 11.5407 11.6913 11.5407Z" fill="#191847"/>
                          </svg>
                          <p class="m-0 bag-info">{{flight.segments[0].classFlight}}</p>
                      </div>
                      <div class="flight-icon d-flex align-items-baseline text-left">
                        <i class="flight-passenger-icon mr-2 fas" [class.fa-user]="getTotalPassengers(flight) === 1" [class.fa-users]="getTotalPassengers(flight) > 1"></i>
                        <p class="m-0 bag-info">{{ getTotalPassengers(flight) }} {{ getTotalPassengers(flight) === 1 ? ('ITINERARY.TRANSPORT.FLIGHT.PASSENGER_SINGULAR' | translate) : ('ITINERARY.TRANSPORT.FLIGHT.PASSENGER_PLURAL' | translate) }}</p>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
      
      <ng-container *ngTemplateOutlet="technicalStopoverTpl"></ng-container>
    </div>

    <ng-container *ngTemplateOutlet="flightNotesTpl"></ng-container>
  </div>

  <!-- Nuova card volo (tenant `enableFlightPassengers`): variante default in flights.component.scss,
       variante CREO in assets/custom/CREO/css/tmteminds.css. Fedele alle bozze `docs/bozza_*_volo_con_passeggeri.html`. -->
  <article class="flight-card" *ngIf="enableFlightPassengers"
    [id]="flight?.code ? 'svc-' + flight.code : null">
    <div class="flight-card__content">
      <div class="flight-card__airline">
        <img *ngIf="getAirlineLogo(flight)" class="flight-card__logo" [src]="getAirlineLogo(flight)"
          [alt]="getAirlineName(flight)">
        <p class="flight-card__number">{{ getFlightNumber(flight) }}</p>
      </div>

      <h2 class="flight-card__title">
        {{ "ITINERARY.TRANSPORT.FLIGHT.DEPARTURE" | translate }}
        <strong>{{ getFirstSegment(flight).departure.airportName }}</strong>
        <br class="flight-card__break-creo">
        {{ "ITINERARY.TRANSPORT.FLIGHT.TO" | translate }}
        <br class="flight-card__break-default">
        <strong>{{ getLastSegment(flight).arrival.airportName }}</strong>
      </h2>

      <div class="flight-card__schedule">
        <div class="flight-card__point">
          <p class="flight-card__iata">{{ getFirstSegment(flight).departure.iata }}</p>
          <time class="flight-card__time" [attr.datetime]="getFirstSegment(flight).departure.hour">{{ getFirstSegment(flight).departure.hour }}</time>
          <p class="flight-card__date">{{ getFirstSegment(flight).departure.date | localizedDate:"EEEE d MMMM" }}</p>
          <p class="flight-card__airport">{{ getFirstSegment(flight).departure.airportName }}</p>
        </div>

        <div class="flight-card__connection" aria-hidden="true">
          <svg class="flight-card__plane" viewBox="0 0 18 15">
            <path
              d="M16.1096 5.75C17.0753 5.75 17.8596 6.53438 17.8596 7.5C17.8596 8.46562 17.0753 9.25 16.1096 9.25H12.1315L7.15652 14.675C6.9659 14.8812 6.70027 15 6.41902 15H5.0534C4.71277 15 4.47215 14.6656 4.5784 14.3406L6.27527 9.25H3.15965L1.50965 11.3125C1.4159 11.4312 1.27215 11.5 1.11902 11.5H0.500272C0.175272 11.5-.0622284 11.1938.0158966 10.8781L.859647 7.5.0158966 4.12187C-.0653534 3.80625.175272 3.5.500272 3.5H1.11902C1.27215 3.5 1.4159 3.56875 1.50965 3.6875L3.15965 5.75H6.27527L4.5784.659375C4.47215.334375 4.71277 0 5.0534 0H6.41902C6.70027 0 6.9659.11875 7.15652.325L12.1315 5.75H16.1096Z" />
          </svg>
        </div>

        <div class="flight-card__point">
          <p class="flight-card__iata">{{ getLastSegment(flight).arrival.iata }}</p>
          <time class="flight-card__time" [attr.datetime]="getLastSegment(flight).arrival.hour">{{ getLastSegment(flight).arrival.hour }}</time>
          <p class="flight-card__date">{{ getLastSegment(flight).arrival.date | localizedDate:"EEEE d MMMM" }}</p>
          <p class="flight-card__airport">{{ getLastSegment(flight).arrival.airportName }}</p>
        </div>

        <div class="flight-card__stopovers" *ngIf="!isDirect(flight.segments)">
          <button class="btn btn-outline-secondary btn-sm rounded-pill" type="button" (click)="isCollapsed = !isCollapsed">
            {{ getStopovers(flight.segments) }} {{ "ITINERARY.TRANSPORT.FLIGHT.STOPOVER" | translate }}
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.48763 7.7418L10.721 10.9751L13.9543 7.7418C14.2793 7.4168 14.8043 7.4168 15.1293 7.7418C15.4543 8.0668 15.4543 8.5918 15.1293 8.9168L11.3043 12.7418C10.9793 13.0668 10.4543 13.0668 10.1293 12.7418L6.3043 8.9168C5.9793 8.5918 5.9793 8.0668 6.3043 7.7418C6.6293 7.42513 7.16263 7.4168 7.48763 7.7418Z" fill="#A0A0A0"/>
            </svg>
          </button>
        </div>
      </div>

      <section class="flight-card__details">
        <div class="flight-card__benefits">
          <p class="flight-card__benefit">
            <svg class="flight-card__icon" viewBox="0 0 12 18" aria-hidden="true">
              <path d="M4 0h4a1 1 0 0 1 1 1v3h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2v1H8v-1H4v1H2v-1a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V1a1 1 0 0 1 1-1Zm1 2v2h2V2H5ZM3 8v1h6V8H3Zm0 4v1h6v-1H3Z" />
            </svg>
            <span *ngIf="flight.segments[0].baggageInfo != null && flight.segments[0].baggageInfo.length > 0; else noBaggageCard"
              [innerHTML]="flight.segments[0].baggage | safeHtml"></span>
          </p>

          <p class="flight-card__benefit">
            <svg class="flight-card__icon" viewBox="0 0 14 16" aria-hidden="true">
              <path d="M7 0a5 5 0 0 0-5 5v3H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v3a1 1 0 0 0 2 0v-3h8v3a1 1 0 0 0 2 0v-3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1V5a5 5 0 0 0-5-5ZM3.5 5a3.5 3.5 0 0 1 7 0v3h-7V5Z" />
            </svg>
            <span>{{ flight.segments[0].classFlight }}</span>
          </p>
        </div>
        <ng-template #noBaggageCard>
          <span>{{ "ITINERARY.TRANSPORT.FLIGHT.NO_BAGGAGE" | translate }}</span>
        </ng-template>

        <div class="flight-card__passengers">
          <h3 class="flight-card__label">{{ "ITINERARY.TRANSPORT.FLIGHT.PASSENGERS" | translate }} ·
            {{ getTotalPassengers(flight) }}</h3>
          <ul class="flight-card__names">
            <li *ngFor="let passenger of getFlightPassengers(flight)">{{ passenger }}</li>
          </ul>
        </div>
      </section>
    </div>
  </article>

  <ng-container *ngIf="enableFlightPassengers">
    <ng-container *ngTemplateOutlet="flightNotesTpl"></ng-container>
    <ng-container *ngTemplateOutlet="technicalStopoverTpl"></ng-container>
  </ng-container>

  <ng-container *ngIf="!isDirect(flight.segments)">
    <div ngbCollapse [ngbCollapse]="!isCollapsed" class="stopovers">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-8 offset-md-4 text-center">
      
            <ng-container *ngFor="let stopover of getScali(flight.segments); let index = index">
              <div class="row" *ngIf="index > 0">
                <div class="col-sm-12 col-md-11 offset-md-1 text-center duration-flight">
                  <span>{{calculateLayoverDuration(flight.segments, index)}} {{ 'ITINERARY.TRANSPORT.FLIGHT.SCALO' | translate }}</span>
                </div>
              </div>
              <div class="row">
                <app-flight-segment-detail class="col-sm-12 col-md-4 offset-md-1" [segment]="stopover"
                  [type]="'departure'">
                </app-flight-segment-detail>
                
                <div class="col-sm-12 col-md-3 p-0 d-flex align-items-center justify-content-center">
                  <div class="text-center flight-duration-wrapper">
                    <div class="flight-segment-duration" *ngIf="stopover.duration">{{ stopover.duration }}</div>
                    <div class="line-flight">
                      <em class="fa fa-plane itinerary-flight ml-2"></em>
                    </div>
                  </div>
                </div>
      
                <app-flight-segment-detail class="col-sm-12 col-md-4" [segment]="stopover"
                  [type]="'arrival'" [showLogo]="false">
                </app-flight-segment-detail>
              </div>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="col-12 mt-2 mb-2"
    *ngIf="(day.transfers != '' || day.hotels != '' ||  day.optionals != '') 
    && day.isLastDay != true">
    <hr class="line-grey">
  </div>
</ng-container>